import React from 'react';
import { Brain, Flame, PlayCircle } from 'lucide-react';
import heroLearner from '../../assets/brand/hero-learner.jpg';

// Matches the reference design the user supplied 2026-08-07 ("RUDVAN-HOME"
// mockup): the hero photo itself already has the "Smarter Learning.
// Brighter Tomorrow." headline, subcopy, book stack, and the single
// numbers-free "AI Study Coach" card baked in (per
// rud-van-studying-with-text.png), so this component only supplies the
// badge above it and the two CTA buttons below it - no duplicate
// headline/subcopy/floating card markup.
export default function HeroSection({ isDarkTheme, onLoginClick }) {
  const badgeBg = isDarkTheme ? 'bg-white/10 border-white/20' : 'bg-surface-light border-gray-200';
  const cardBg = isDarkTheme ? 'bg-navy/90 border-white/10' : 'bg-white border-gray-200';

  return (
    <section id="top" className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-6 sm:pb-16 md:pt-14">
      <div className="flex justify-center sm:justify-start mb-6">
        <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border ${badgeBg} backdrop-blur-sm`}>
          <Brain size={16} className="text-brand-blue" />
          <span className={`text-sm font-semibold ${isDarkTheme ? 'text-white' : 'text-brand-blue'}`}>
            AI-Powered Adaptive Learning Platform
          </span>
        </div>
      </div>

      <div className={`rounded-card border ${cardBg} shadow-brand-lg overflow-hidden`}>
        <img
          src={heroLearner}
          alt="Two learners studying together with RUDVAN's AI Study Coach, adaptive practice, and their Mathematics, Physics, and Chemistry books"
          className="w-full h-auto block"
          width={1536}
          height={1024}
        />
      </div>

      {/* Fixed 2026-09-02 (real report, tablet): was gap-3 sm:gap-4 - same
          Google Translate `<font>`-tag DOM-injection issue confirmed for
          LandingHeader.jsx's nav (docs/DECISIONS.md) breaking CSS flex `gap`
          spacing. space-x-* is margin-based (targets the two <button>
          elements themselves, not their translated inner text), immune to
          the same failure mode. */}
      <div className="flex flex-row justify-center space-x-3 sm:space-x-4 mt-8">
        <button
          onClick={onLoginClick}
          className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 sm:gap-3 px-4 sm:px-8 py-3 sm:py-4 rounded-btn bg-brand-blue hover:bg-brand-blue-hover text-white font-bold text-base sm:text-lg transition-all duration-300 shadow-brand-btn hover:scale-[1.02]"
        >
          <Flame size={20} className="shrink-0" />
          Start Learning Today
        </button>
        <button
          onClick={onLoginClick}
          className={`flex-1 sm:flex-none inline-flex items-center justify-center gap-2 sm:gap-3 px-4 sm:px-8 py-3 sm:py-4 rounded-btn border-2 border-solid font-bold text-base sm:text-lg transition-all duration-300 shadow-brand-md hover:scale-[1.02] ${
            isDarkTheme
              ? 'bg-white/10 border-white/20 text-white hover:bg-white/20'
              : 'bg-white border-brand-blue text-brand-blue hover:bg-surface-light'
          }`}
        >
          <PlayCircle size={20} className="shrink-0" />
          Watch Demo
        </button>
      </div>
    </section>
  );
}
